import React from 'react'

import { graphql, Link } from 'gatsby'

import Img from '../components/Img'

const LeadershipSection = ({ slice }) => {
  const { primary, items } = slice

  return (
    <section className={`section leadership-section ${primary?.page}`}>
      <div className="container">
        <div className="leadership-box">
          <h2 className="title">{primary?.title?.text}</h2>
          <div className="leadership-list">
            {items?.map((item) => {
              const person = item?.person?.document?.data
              return (
                <div key={item} className="leadership-item">
                  <Img
                    image={person?.photo?.gatsbyImageData}
                    alt={person?.photo?.alt}
                    className="author-image"
                  />
                  <div className="author-info">
                    <p className="author-name">{person?.name}</p>
                    <p className="author-position">{person?.position}</p>
                    <ul className="social-list">
                      {person?.socials?.map((social) => (
                        <Link
                          className="social-link"
                          key={social}
                          to={social?.social_link?.url}
                          target={social?.social_link?.target}
                        >
                          <Img
                            image={social?.social_icon?.gatsbyImageData}
                            alt={social?.social_icon?.alt}
                            className="social-image"
                          />
                        </Link>
                      ))}
                    </ul>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default LeadershipSection

export const query = graphql`
  fragment AboutUsPageDataBodyLeadershipSection on PrismicAboutUsPageDataBodyLeadershipSection {
    id
    slice_type
    primary {
      title {
        text
      }
    }
    items {
      person {
        document {
          ... on PrismicPerson {
            id
            data {
              name
              photo {
                gatsbyImageData
                alt
              }
              position
              socials {
                social
                social_icon {
                  alt
                  gatsbyImageData
                }
                social_link {
                  url
                  target
                }
              }
            }
          }
        }
      }
    }
  }
`
